import { Component, OnDestroy } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { NgbNav, NgbNavContent, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap'

import { BaseComponent, Grid } from '../../shared'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'

@Component({
    templateUrl: './validation.component.html',
    standalone: true,
    imports: [
        NgbNav,
        NgbNavItem,
        NgbNavItemRole,
        NgbNavLink,
        NgbNavLinkBase,
        NgbNavContent,
        FormsModule,
        ActionToolbarCount,
        ActionToolbarSearchComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
        NgbNavOutlet,
    ],
})
export class ValidationComponent extends BaseComponent implements OnDestroy {
    faSearch = faSearch
    finishedGoodComponent: any[] = []
    componentNoFinishedGoodParent: any[] = []
    grid1: Grid<any>
    active = 1

    constructor() {
        super()

        this.grid1 = new Grid<any>(this.services).wrapColumnHeaders().filterBy(item => [item.e, item.j, item.vj])
        this.refresh()
    }

    refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data.load(true, true, this.services.data.get('api/Validation/QueryGPSRecords')).subscribe({
                next: result => {
                    this.initialLoadingComplete()
                    this.grid1.items = result[0]
                },
            }),
        )
    }
}
